module.exports = __webpack_public_path__ + "img/data-title.0d44f10e.png";